module.exports = __webpack_public_path__ + "img/shipment_ready_boxes.0dd8ca7a.png";